<template lang="html">
  <div class="row middle" style="margin: 0 -.3em">
    <a :href="channel.link" :title="channel.title" target="_blank" v-for="channel in channels">
      <i class="fa" :class="channel.icon"></i>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      channels: [
        {
          title: "GitHub",
          link: "https://github.com/crsten",
          icon: "fa-github"
        },
        {
          title: "CodePen",
          link: "https://codepen.io/crsten",
          icon: "fa-codepen"
        },
        {
          title: "Epost",
          link: "mailto:carsten@elder.no",
          icon: "fa-envelope-o"
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
@import "../styles/base/_colors";

a {
  color: $tertiary;
  padding: 0.3em;
}
</style>
